import * as React from "react";
import { forwardRef, memo } from "react";
const SvgCaretDown = (props, ref) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M17 9.53546L12 14.5355L7 9.53546", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "square", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgCaretDown);
const Memo = memo(ForwardRef);
export default Memo;
